module.exports = __webpack_public_path__ + "img/word.bc6f3a92.png";